<template lang="pug">
  ods-module.ods-dashboard
    h2.ods-dashboard__title ¡Te presentamos el ODS v3!

    .ods-dashboard__desc
      p ODS.js es una librería pensada y desarrollada para acelerar la construcción frontend de productos y proyectos. Contiene una completa colección de componentes desarrollados para Vue.js, con una funcionalidad y estilos perfectamente adecuados para la gran variedad de productos y suites que componen Onesait. Desde los componentes básicos (átomos) hasta componentes complejos que aceleran la construcción a la vez que imprimen la máxima calidad.  Pero no solo eso. ODS.js v3 viene además con una gran cantidad de helpers y mixins para sacar el máximo provecho de los preprocesadores css y las últimas versiones de ECMAScript (especificación estándar de Javascript). Estas son su características más destacadas:

      .ods-dashboard__desc__actions
        ods-button(icon="ods-icon-note" icon-position="left" class="ods-dashboard__docu-btn" @click="goToDoc") Ver documentación
        ods-button(icon="ods-icon-art-tools" icon-position="left" @click="goToStorybook") Ver componentes

    section.ods-dashboard__grid
      article.ods-dashboard__box
        h4.ods-dashboard__box__subtitle Estilos centralizados y gobernados por el equipo de diseño de Onesait UX
        h3.ods-dashboard__box__title Design tokens
        p.ods-dashboard__box__desc Los tokens de diseño son piezas centrales y diminutas de información de la interfaz de usuario para almacenar información relacionada con el diseño, como colores, fuentes, espacios, animaciones, etc. Sus beneficios son que se pueden transformar y formatear para satisfacer las necesidades de cualquier plataforma (Android, iOS , Web, etc…). Esto añade una capa más de control a los estándares Onesait, la calidad final, y la imagen de marca para distintos productos, sin importar la tecnología en que estén construidos, facilitando la colaboración entre los equipos de producto y garantizando la coherencia de marca a través de cualquier plataforma específica.

      article.ods-dashboard__box
        h4.ods-dashboard__box__subtitle Más que un framework de componentes
        h3.ods-dashboard__box__title Completo ecosistema de desarrollo frontend
        p.ods-dashboard__box__desc La librería de componentes ODS para vue.js forma parte de un ecosistema más completo y no debe entenderse como una librería aislada. Si bien por su construcción puede utilizarse de forma autónoma en cualquier proyecto vue, está entendido y pensado para formar una parte más del amplio ecosistema frontend, funcionando mejor en compañía de otras herramientas aceleradoras: Figma, como motor centralizado de estilos. Storybook para documentación, ejemplos y pruebas de uso de componentes, helpers de css con clases específicas para tipografías, uso de flex, conversor de píxeles a rem... CLI para la creación de la estructura de carpetas y construcción del contenedor de cualquier proyecto. Plugin de atajos para IDEs, para facilitar la inserción de componentes ODS en el desarrollo... La librería de componentes debe pensarse como una parte más de un completo Sistema de Diseño.

      article.ods-dashboard__box
        h4.ods-dashboard__box__subtitle Personalización de temas
        h3.ods-dashboard__box__title Modo light, dark y Custom themes
        p.ods-dashboard__box__desc La nueva versión 3 de ODS con la tecnología de Design Tokens implementa la posibilidad de cambiar de modo light a modo dark de manera automática.  También permite la construcción de una paleta de estilos personalizada para los proyectos.
        img(src="@/assets/images/hello-ods/themes.png" class="ods-dashboard__box__image")

      article.ods-dashboard__box
        h4.ods-dashboard__box__subtitle Personalización de temas
        h3.ods-dashboard__box__title Un sistema multi-brand
        p.ods-dashboard__box__desc Somos capaces de adaptar nuestro sistema de diseño al branding de cada uno de nuestros clientes. De forma rápida y automática, y totalmente controlada y centralizada desde el equipo de diseño de Onesait UX y basándose en la tecnología de los design tokens, podrás aplicar themes personalizados para ambos modos claro y oscuro.
        img(src="@/assets/images/hello-ods/multibrand.png" class="ods-dashboard__box__image")

      article.ods-dashboard__box.ods-dashboard__box--large
        h3.ods-dashboard__box__title Muchas más novedades
        p.ods-dashboard__box__desc Descubre todo lo que puedes hacer. La mejor manera es probándolo, asique ¿a qué esperas?

        .ods-dashboard__news
          .ods-dashboard__news__box
            div.ods-flex-1
              h5.ods-dashboard__news__title Más accesibles que nunca
              p.ods-dashboard__news__desc Un buen uso del color permite a los usuarios con diversas capacidades utilizar correctamente  nuestras interfaces.
            div.ods-dashboard__news__image-wrap
              img(src="@/assets/images/hello-ods/a11y.png" class="ods-dashboard__news__image")

          .ods-dashboard__news__box.ods-dashboard__news__box--opt
            div.ods-flex-1
              h5.ods-dashboard__news__title Mejor optimización y distribución del espacio
              p.ods-dashboard__news__desc Con el objetivo de mejorar la lectura de los usuarios y aprovechar mejor el espacio, hemos reestructurado la disposición de elementos en nuestro grid.
            div.ods-dashboard__news__image-wrap
              img(src="@/assets/images/hello-ods/optimization.png" class="ods-dashboard__news__image")

          .ods-dashboard__news__box.ods-dashboard__news__box--comp
            div.ods-flex-1
              h5.ods-dashboard__news__title Más y mejores componentes
              p.ods-dashboard__news__desc Incluye mejorías sobre lo que ya teníamos y cuenta con nuevos elementos. Las formas pasan de ser redondas, a cuadradas, proporcionando estabilidad, robustez y seguridad.
            div.ods-dashboard__news__image-wrap
              img(src="@/assets/images/hello-ods/components.png" class="ods-dashboard__news__image")

          .ods-dashboard__news__box.ods-dashboard__news__box--optim--typo
            div.ods-flex-1
              h5.ods-dashboard__news__title Una tipografía adaptada para una mejor legibilidad
              p.ods-dashboard__news__desc En esta nueva versión estrenamos nueva jerarquía y escala de tipografía. Además, incluimos una nueva tipografía mono espaciada para código e indicadores numéricos.
            div.ods-dashboard__news__image-wrap
              img(src="@/assets/images/hello-ods/typography.png" class="ods-dashboard__news__image")

</template>

<script>
export default {
  name: 'HelloODS',

  methods: {
    goToDoc () {
      window.open('https://mind.indra.es/pages/viewpage.action?pageId=447432543', '_blank')
    },

    goToStorybook () {
      window.open('https://lab.onesaitplatform.com/web/ods-storybook-v3/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
/*
  Dashboard base & description
 */

.ods-dashboard {
  padding: $space-300 $space-100 $space-100 $space-100;

  &__title {
    @include txt-title-400;
    margin-bottom: $space-200;
  }

  &__desc {
    padding-bottom: $space-400;
    @include txt-body-400;

    @include mediaSm {
      display: flex;
    }

    &__actions {
      padding-top: $space-200;

      @include mediaSm {
        text-align: right;
        padding: 0 0 0 $space-300;

        .ods-dashboard__docu-btn {
          margin-bottom: $space-200;
        }
      }
    }
  }
}

.ods-dashboard{

  /*
  Dashboard grid
 */

  &__grid {
    @include mediaSm {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: $space-050;
    }
  }

  /*
  Dashboard box
 */

  &__box {
    background-color: var(--color-bg-secondary);
    padding: $space-200 $space-500;
    margin-bottom: $space-100;

    @include mediaSm {
      margin-bottom: 0;
    }

    &--large {
      grid-column: 1 / span 2;
    }

    &__title {
      position: relative;
      @include txt-title-200;
      padding-bottom: $space-300;

      &::after {
        content: '';
        position: absolute;
        bottom: rem(12);
        left: 0;
        width: rem(72);
        height: rem(4);
        background-color: var(--color-bg-hover);
      }
    }

    &__subtitle {
      @include txt-subtitle-100;
      padding-bottom: $space-100;
    }

    &__desc {
      @include txt-body-400;
    }

    &__image {
      max-width: 100%;
      margin-top: $space-300;
    }
  }
}

/*
  Dashboard news
 */

.ods-dashboard__news {
  padding-top: $space-200;

  @include mediaSm {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $space-400;
  }

  &__box {
    --border-color: var(--color-data-categorical-green);

    display: flex;
    border-left: $border-size-400 solid var(--border-color);
    padding-left: $space-200;
    margin-bottom: $space-300;

    @include mediaSm {
      margin-bottom: 0;
    }

    &--opt {
      --border-color: var(--color-data-categorical-yellow);
    }

    &--comp {
      --border-color: var(--color-data-categorical-garnet);
    }

    &--typo {
      --border-color: var(--color-data-categorical-magenta);
    }
  }

  &__title {
    @include txt-title-150;
    padding-bottom: $space-100;
  }

  &__desc {
    @include txt-body-400
  }

  &__image-wrap {
    flex-basis: rem(200);
    text-align: center;
    padding-left: $space-200;
  }
}

</style>
